module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CH - Switzerland.29be3367.svg";